import { useEffect, useState, useRef } from "react";
import { Link } from 'react-router-dom';
import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";
import { FaBell } from 'react-icons/fa';
import '../../../styles/notification.css';
import notificationService from '../../../services/notificationService';
import { useWebNotificationContext } from "../../../contexts/WebNotificationContext";
import { useLocation } from 'react-router-dom'; // Add this line

const WebNotification = ({ userId }) => {
  const { fetchUserNotifications } = notificationService();
  const [notifications, setNotifications] = useState([]);
  //const [unreadCount, setUnreadCount] = useState(0);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const socketUrl = process.env.REACT_APP_API_BASE_URL;
  const { unreadCount, setUnreadCount } = useWebNotificationContext();

  const dropdownRef = useRef(null);  // Track the dropdown
  const location = useLocation();    // Track current route

  // CLOSE ON OUTSIDE CLICK
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // CLOSE ON ROUTE CHANGE
  useEffect(() => {
    setDropdownVisible(false);
  }, [location]);

  useEffect(() => {
    const socket = new SockJS(`${socketUrl}/socket`);
    const stompClient = new Client({
      webSocketFactory: () => socket,
      // debug: (msg) => console.log(`STOMP Debug (${userId}): ${msg}`),
    });

    stompClient.onConnect = () => {
      stompClient.subscribe(`/topic/notifications/${userId}`, (message) => {
        if (!message.body) return;
                
        const newNotification = JSON.parse(message.body);

        if (!newNotification.id || !newNotification.message) return;

        setNotifications((prev) => {
          // Avoid duplicates by ID
          const exists = prev.some(n => n.id === newNotification.id);
          return exists ? prev : [newNotification, ...prev];
        });
        setUnreadCount((prev) => prev + 1);
      });
    };

    stompClient.activate();

    return () => {
      stompClient.deactivate();
    };
  }, [userId]);

  useEffect(() => {
    const loadNotifications = async () => {
      try {        
        const data = await fetchUserNotifications(userId);        
        setNotifications(data.content || []);
        const unread = data.content?.filter(n => !n.isRead).length || 0;
        setUnreadCount(unread);
      } catch (error) {
        console.error(error);
      }
    };

    if (userId) {
      loadNotifications();
    }
  }, [userId]);

  const toggleDropdown = () => {
    setDropdownVisible((prev) => !prev);
  };

  return (
    <div className="notification-container" ref={dropdownRef}>
      <button className="bell-icon" onClick={toggleDropdown}>
        <FaBell size={27} color={unreadCount > 0 ? 'red' : 'black'} />
      </button>

      {isDropdownVisible && (
        <div className="notification-list">
          {notifications.slice(0, 5).map((note, index) => (
            <Link to={`/notifications/${note.id}`} state={{ fromBellIcon: true }} key={index} className="notification-item">
              {note.message}
            </Link>
          ))}
          <Link to="/notifications" className="view-all-button">View All</Link>
        </div>
      )}
    </div>
  );

};

export default WebNotification;
